import { render, staticRenderFns } from "./Herder.vue?vue&type=template&id=5c7196cb&scoped=true"
import script from "./Herder.vue?vue&type=script&lang=js"
export * from "./Herder.vue?vue&type=script&lang=js"
import style0 from "./Herder.vue?vue&type=style&index=0&id=5c7196cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7196cb",
  null
  
)

export default component.exports